import React from 'react'
import { Content } from '../../../components'

interface EditorialTemplateProps {
  label: string
  title: string
  subtitle?: string
  children: React.ReactNode
}

export const EditorialTemplate = ({
  label,
  title,
  subtitle,
  children
}: EditorialTemplateProps) => {
  return (
    <Content padding="0">
      <main
        style={{
          width: '100%',
          backgroundColor: '#f3efe7',
          color: '#171714',
          fontFamily: 'Georgia, "Times New Roman", serif'
        }}
      >
        <header
          style={{
            padding: '40px clamp(20px, 7vw, 110px) 72px',
            borderBottom: '1px solid #171714'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '24px',
              marginBottom: '64px',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '11px',
              letterSpacing: '2px',
              textTransform: 'uppercase'
            }}
          >
            <span>Made to Wear</span>
            <span>{label}</span>
          </div>

          <h1
            style={{
              maxWidth: '1100px',
              margin: 0,
              fontSize: 'clamp(52px, 9vw, 126px)',
              lineHeight: '0.92',
              fontWeight: 400,
              letterSpacing: '-0.055em'
            }}
          >
            {title}
          </h1>

          {subtitle && (
            <p
              style={{
                maxWidth: '720px',
                margin: '36px 0 0',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '20px',
                lineHeight: '1.7'
              }}
            >
              {subtitle}
            </p>
          )}
        </header>

        <article
          style={{
            maxWidth: '760px',
            margin: '0 auto',
            padding: '88px 24px 110px',
            fontSize: '20px',
            lineHeight: '1.85'
          }}
        >
          {children}
        </article>
        <section
          style={{
            maxWidth: '760px',
            margin: '0 auto',
            padding: '0 24px 96px',
            textAlign: 'center',
            borderTop: '1px solid #d8d2c8'
          }}
        >
          <p
            style={{
              margin: '56px 0 20px',
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: '30px',
              lineHeight: '1.4',
              fontWeight: 400
            }}
          >
            Ready for your next custom-made piece?
          </p>

          <p
            style={{
              maxWidth: '620px',
              margin: '0 auto 36px',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '18px',
              lineHeight: '1.8'
            }}
          >
            Explore exceptional clothing, shoes, bags and accessories created by
            talented designers and artisans across Africa.
          </p>

          <a
            href="/"
            style={{
              display: 'inline-block',
              padding: '18px 36px',
              border: '1px solid #171714',
              color: '#171714',
              textDecoration: 'none',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '12px',
              fontWeight: 700,
              letterSpacing: '2px',
              textTransform: 'uppercase'
            }}
          >
            Shop OvafloPick →
          </a>
        </section>

        <footer
          style={{
            padding: '56px 24px',
            backgroundColor: '#171714',
            color: '#f3efe7',
            textAlign: 'center'
          }}
        >
          <a
            href="/madetowear"
            style={{
              color: '#f3efe7',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '12px',
              fontWeight: 700,
              letterSpacing: '2px',
              textDecoration: 'none',
              textTransform: 'uppercase'
            }}
          >
            Return to Made to Wear
          </a>
        </footer>
      </main>
    </Content>
  )
}
